import { Alert, Button } from 'framework/ui/mui-builder';
import { getErrorMessage } from '../utils/format';

type ErrorNoticeProps = {
  error: unknown;
  onRetry?: () => void;
};

const ErrorNotice = ({ error, onRetry }: ErrorNoticeProps) => (
  <Alert
    severity="error"
    action={
      onRetry ? (
        <Button size="small" color="error" onClick={onRetry}>
          Retry
        </Button>
      ) : undefined
    }
  >
    {getErrorMessage(error)}
  </Alert>
);

export default ErrorNotice;
